/* eslint-disable */

/** select columns of table "argo.vw_timestamptz" */
export enum ArgoVwTimestamptzSelectColumn {
  /** column name */
  CurrentTimestamp = 'current_timestamp',
  /** column name */
  DateTruncCentury = 'date_trunc_century',
  /** column name */
  DateTruncDay = 'date_trunc_day',
  /** column name */
  DateTruncDecade = 'date_trunc_decade',
  /** column name */
  DateTruncHour = 'date_trunc_hour',
  /** column name */
  DateTruncMicroseconds = 'date_trunc_microseconds',
  /** column name */
  DateTruncMillennium = 'date_trunc_millennium',
  /** column name */
  DateTruncMilliseconds = 'date_trunc_milliseconds',
  /** column name */
  DateTruncMinute = 'date_trunc_minute',
  /** column name */
  DateTruncMonth = 'date_trunc_month',
  /** column name */
  DateTruncQuarter = 'date_trunc_quarter',
  /** column name */
  DateTruncSecond = 'date_trunc_second',
  /** column name */
  DateTruncWeek = 'date_trunc_week',
  /** column name */
  DateTruncYear = 'date_trunc_year',
  /** column name */
  Now = 'now'
}

